import { Component, DestroyRef, computed, inject, input } from '@angular/core';
import { ToastMessage } from '../models/toast.model';
import { ToastService } from '../services/toast.service';

const TIME_OUT_MS = 4000;
const EXTENDED_TIME_OUT_MS = 5000;

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  host: {
    '[class]': 'kindClass()',
    '[attr.role]': 'role()',
    '(mouseenter)': 'holdOpen()',
    '(mouseleave)': 'resumeDismiss()'
  }
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);
  private dismissTimer?: ReturnType<typeof setTimeout>;

  public readonly toast = input.required<ToastMessage>();

  protected readonly kindClass = computed(() => `toast-${this.toast().kind}`);
  protected readonly role = computed(() => (this.isUrgent() ? 'alert' : 'status'));

  constructor() {
    this.scheduleDismiss(TIME_OUT_MS);
    inject(DestroyRef).onDestroy(() => this.holdOpen());
  }

  protected holdOpen(): void {
    clearTimeout(this.dismissTimer);
  }

  protected resumeDismiss(): void {
    this.scheduleDismiss(EXTENDED_TIME_OUT_MS);
  }

  protected close(): void {
    this.toastService.dismiss(this.toast().id);
  }

  private scheduleDismiss(delayMs: number): void {
    this.holdOpen();
    this.dismissTimer = setTimeout(() => this.close(), delayMs);
  }

  private isUrgent(): boolean {
    const kind = this.toast().kind;
    return kind === 'error' || kind === 'warning';
  }
}
